import { Sparkle } from 'lucide-react';

const GeoffreySummaryCard = ({ summary, heldForReview = [], fontSize }) => {
  if (!summary) return null;

  const heldCount = heldForReview.length;

  return (
    <div className="flex flex-col items-stretch">
      <div
        className="flex items-center gap-2 px-3 py-2 rounded-t-2xl border border-b-0 border-slate-200 bg-gradient-to-b from-slate-50 to-slate-100"
        style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
      >
        <span className="inline-flex items-center justify-center bg-blue-100 rounded-full p-1">
          <Sparkle size={16} />
        </span>
        <span className="font-semibold text-slate-800 text-xs uppercase tracking-wide">
          Geoffrey Summary
        </span>
      </div>
      <div
        className="px-4 py-3 bg-slate-50 border border-slate-200 border-t-0 rounded-b-2xl"
        style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, fontSize }}
      >
        <p className="text-slate-700 text-sm">
          <span dangerouslySetInnerHTML={{ __html: summary }} />
        </p>
        {heldCount > 0 && (
          <p className="mt-2 text-xs text-slate-600">
            Geoffrey held {heldCount} {heldCount === 1 ? 'suggestion' : 'suggestions'} for your review.
          </p>
        )}
      </div>
    </div>
  );
};

export default GeoffreySummaryCard;
